import { Paper, Title } from '@mantine/core';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { EmailsByDate } from '../types';

interface EmailsOverTimeChartProps {
    data: EmailsByDate[];
}

export const EmailsOverTimeChart = ({ data }: EmailsOverTimeChartProps) => {
    return (
        <Paper p="md" withBorder>
            <Title order={4} mb="md">Emails Over Time</Title>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="sent" stroke="#228be6" name="Sent" />
                    <Line type="monotone" dataKey="received" stroke="#40c057" name="Received" />
                </LineChart>
            </ResponsiveContainer>
        </Paper>
    );
};
